import { DTOResponseCheckoutURL } from "./Subscription/CheckoutURL.interface";
import axiosSecure from "./axiosSecure";

export const callSubscriptionCheckout = async (accessToken: string) => {
  const response = await axiosSecure(accessToken).get<DTOResponseCheckoutURL>(
    "/subscription/checkout",
  );
  return response.data;
};
